import React from 'react'
import PropTypes from 'prop-types'
import Slider from "react-slick"

import NumberFormat from 'react-number-format';
// Atom
// import Button from './../../../../Components/Atoms/Button'

// Mol
import PlayPlanCardMol from './../../../../Components/Molecules/Cards/Plan/Play'
import { useState } from 'react'

import Parser from 'html-react-parser';

// sass, styles
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Perfilador4PeopleOrg(props) {
    const {
        handleChangeCurrentPage,
        questionsAnswers,
        contenidoSel,
        planes,
        legales,
    } = props
    const contenido = contenidoSel ? contenidoSel?.map(c => {
        return `${c?.desc} ${c?.value}`
    }).join(', ') : ''
    const [settingsSlider] = useState({
        responsive: [
            {
                breakpoint: 100000,
                settings: 'unslick'
            },
            {
                breakpoint: 960,
                settings: {
                    autoplay: false,
                    // autoplay: true,
                    autoplaySpeed: 7000,
                    speed: 600,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: false,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    autoplay: false,
                    // autoplay: true,
                    autoplaySpeed: 7000,
                    speed: 600,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: false,
                }
            },

        ]

    })
    let AmountPneracion = 0;

    questionsAnswers?.map((Sectionquestions, index) => {
        let total = 0, totalask = 0, totalansw = 0
        console.log("Sectionquestions", Sectionquestions)

        Sectionquestions.map((ask, ind) => {
            console.log("ask", ask)
            ask.perfiladorRespuestas.map((answ, keyansw) => {

                console.log("perfiladorRespuestas: ", answ, answ.fi_RESPUESTA, answ.fi_PONDERACION)

                if (ask.fi_TIPO === 1) {
                    if (ask?.IdAnswSelected === answ.fi_RESPUESTA) {
                        totalansw += answ.fi_PONDERACION
                        AmountPneracion += answ.fi_PONDERACION
                        console.log("Select : ", AmountPneracion)
                    }
                }

                if (ask.fi_TIPO === 2 && answ.selected === true) {
                    totalansw += answ.fi_PONDERACION
                    AmountPneracion += answ.fi_PONDERACION
                    console.log("Radio: ", AmountPneracion)
                }

                if (ask.fi_TIPO === 3 && answ?.InputValNum) {
                    totalansw += answ.fi_PONDERACION
                    AmountPneracion += answ.fi_PONDERACION
                    console.log("Inpunt number: ", AmountPneracion)
                }

                if (ask.fi_TIPO === 4 && answ.checked === true) {
                    totalansw += answ.fi_PONDERACION
                    AmountPneracion += answ.fi_PONDERACION
                    console.log("checkbox:", AmountPneracion)
                }

                return totalansw
            })
            // totalask += totalansw
            console.log("total Preguntas: ", totalask)
            return totalask
        })
        total += totalask
        console.log("total Sections Preguntas: ", totalansw)
        return total
    })
    function getplanIdeal(){
        let planesIdeales = planes?.find(p => p.megas_SUBIDA >= AmountPneracion)
        if(!planesIdeales){
            planesIdeales = planes.find(p => {
                return p.caracteristicas.find( c => c.megas_SUBIDA >= AmountPneracion)
            })
        }
        if(!planesIdeales){
            const maximum = Math.max(...planes.map((i) => i.megas_SUBIDA));
            planesIdeales = planes?.find(p => p.megas_SUBIDA >= maximum)
            if(!planesIdeales){
                planesIdeales = planes.find(p => {
                    return p.caracteristicas.find( c => c.megas_SUBIDA >= maximum)
                })
            }
        }
        return planesIdeales
    }
    const planIdeal = getplanIdeal();
    
    return (
        <section className="light">
            <div className="container">
                <div className="perfiladorTitle">
                    <h2>¡Felicidades!</h2>
                    <p>De acuerdo al uso que configuraste</p>
                    <p>{contenido}</p>
                    <h4>Encontramos el Plan ideal para ti</h4>
                </div>
                <div className="perfiladorFinal">
                    <PlayPlanCardMol 
                        title={planIdeal.fc_TEXTO_CAJA}
                        titlestyle={planIdeal?.fc_COLOR_CAJA ? planIdeal?.fc_COLOR_CAJA.toLowerCase() : null}
                        name={planIdeal.fc_NOMBRE}
                        fi_PLAN={planIdeal.fi_PLAN}
                        fc_DESCRIPCION={planIdeal.fc_DESCRIPCION}
                        fi_NUMERO_CARACTERISTICAS_MOSTRAR={planIdeal.fi_NUMERO_CARACTERISTICAS_MOSTRAR}
                        fc_TITULO_CARACTERISTICAS_AGRUPADAS={planIdeal.fc_TITULO_CARACTERISTICAS_AGRUPADAS}
                        fi_PRECIO_PLAN={<NumberFormat thousandSeparator={"."} decimalSeparator={","} displayType={'text'} value={planIdeal.fi_PRECIO_PLAN} />}
                        fc_COLOR_PRECIO={planIdeal.fc_COLOR_PRECIO}
                        fc_ETIQUETA_PRECIO_TACHADO={planIdeal.fc_ETIQUETA_PRECIO_TACHADO}
                        fc_PRECIO_TACHADO={<NumberFormat thousandSeparator={"."} decimalSeparator={","} displayType={'text'} value={planIdeal.fc_PRECIO_TACHADO} />}
                        fc_NOTA_DEBAJO_PRECIO={planIdeal.fc_NOTA_DEBAJO_PRECIO}
                        fc_TEXTO_DETALLE={planIdeal.fc_TEXTO_DETALLE}
                        fc_URL_DETALLE={planIdeal.fc_URL_DETALLE}
                        fc_TARGET_DETALLE={planIdeal.fc_TARGET_DETALLE}
                        fc_OPCION_CONTRATACION={planIdeal.fc_OPCION_CONTRATACION}
                        fc_TEXTO_CONTRATAR={planIdeal.fc_TEXTO_CONTRATAR}
                        fc_URL_CONTRATAR={planIdeal.fc_URL_CONTRATAR}
                        fc_TARGET_CONTRATAR={planIdeal.fc_TARGET_CONTRATAR}
                        fc_ETIQUETA_PERIODO={planIdeal.fc_ETIQUETA_PERIODO}
                        Caracteristicas={planIdeal.caracteristicas}
                        Acordeon={planIdeal.acordeon}
                        lstPlanContratacionxPlan={planIdeal.lstPlanContratacionxPlan}
                    />

                    {
                        legales && Parser(legales.find(l => l.fc_BLOQUE === "LEP").fc_HTML_AVANZADO)
                    }
                    <div className="perfiladorFinalAdd">
                        {
                            legales && Parser(legales.find(l => l.fc_BLOQUE === "REC").fc_HTML_AVANZADO)
                        }
                        <div className="perfiladorFinalAddCarousel">
                        
                            {/* <div className="perfFinalAddCarSlider"> */}
                            <Slider
                                {...settingsSlider}
                                className={`perfFinalAddCarSlider`}
                            >
                                <div className="perfFinalAddCarSld">
                                    <div className="perfFinalSldImg">
                                        <picture>
                                            <source data-srcset={`${process.env.PUBLIC_URL}/assets/img/img-producto-01.webp`} type="image/webp" />
                                            <source data-srcset={`${process.env.PUBLIC_URL}/assets/img/img-producto-01.png`} type="image/png" />
                                            <img className="lazyload" data-src={`${process.env.PUBLIC_URL}/assets/img/img-producto-01.png`} alt="" width="120" height="220" />
                                        </picture>
                                    </div>
                                    <div className="perfFinalSldCont">
                                        <div className="perfFinalSldTitle">
                                            <h3>
                                                Nebula 301 Repetidor
                                                <strong>Lorem Ipsum</strong>
                                            </h3>
                                        </div>
                                        <div className="perfFinalSldPrice">
                                            <p>Antes: $900</p>
                                            <p className="currentPrice">
                                                <strong>$1,000</strong>
                                            </p>
                                        </div>
                                        <a href="#!">Agregar al Carrito</a>
                                    </div>
                                </div>
                                <div className="perfFinalAddCarSld">
                                    <div className="perfFinalSldImg">
                                        <picture>
                                            <source data-srcset={`${process.env.PUBLIC_URL}/assets/img/img-producto-02.webp`} type="image/webp" />
                                            <source data-srcset={`${process.env.PUBLIC_URL}/assets/img/img-producto-02.png`} type="image/png" />
                                            <img className="lazyload" data-src={`${process.env.PUBLIC_URL}/assets/img/img-producto-02.png`} alt="" width="120" height="220" />
                                        </picture>
                                    </div>
                                    <div className="perfFinalSldCont">
                                        <div className="perfFinalSldTitle">
                                            <h3>
                                                Nebula 302 Repetidor
                                                <strong>Lorem Ipsum</strong>
                                            </h3>
                                        </div>
                                        <div className="perfFinalSldPrice">
                                            <p>Antes: $900</p>
                                            <p className="currentPrice">
                                                <strong>$1,000</strong>
                                            </p>
                                        </div>
                                        <a href="#!">Agregar al Carrito</a>
                                    </div>
                                </div>
                                <div className="perfFinalAddCarSld">
                                    <div className="perfFinalSldImg">
                                        <picture>
                                            <source data-srcset={`${process.env.PUBLIC_URL}/assets/img/img-producto-01.webp`} type="image/webp" />
                                            <source data-srcset={`${process.env.PUBLIC_URL}/assets/img/img-producto-01.png`} type="image/png" />
                                            <img className="lazyload" data-src={`${process.env.PUBLIC_URL}/assets/img/img-producto-01.png`} alt="" width="120" height="220" />
                                        </picture>
                                    </div>
                                    <div className="perfFinalSldCont">
                                        <div className="perfFinalSldTitle">
                                            <h3>
                                                Nebula 303 Repetidor
                                                <strong>Lorem Ipsum</strong>
                                            </h3>
                                        </div>
                                        <div className="perfFinalSldPrice">
                                            <p>Antes: $900</p>
                                            <p className="currentPrice">
                                                <strong>$1,000</strong>
                                            </p>
                                        </div>
                                        <a href="#!">Agregar al Carrito</a>
                                    </div>
                                </div>

                            </Slider>
                            {/* </div> */}
                        </div>
                    </div>
                    {
                        legales && Parser(legales.find(l => l.fc_BLOQUE === "LEG").fc_HTML_AVANZADO)
                    }
                </div>
                <div className="perfiladorBtns perfBtn04">
                    {/* <Button>
                        Volver a calcular
                    </Button> */}
                    <button className='btn btnPrimario' type='submit' value='Perfilador1Org' onClick={(e) => { handleChangeCurrentPage(e, null, 'init') }}>
                        Volver a calcular
                    </button>
                </div>
            </div>
        </section>
    )
}
Perfilador4PeopleOrg.dafaultProps = {
    items: [{}, {}, {}]
}
Perfilador4PeopleOrg.propTypes = {
    items: PropTypes.array
}
export default Perfilador4PeopleOrg
